<template>
	<div v-if="this.$checkStatusResponse(this.status)">
		<section>
			<div class="container col-lg-11 mt-5">
				<card noBody="" type="secondary" style="margin-top: 150px;">
					<div class="container">
						<div class="pl-0">
							<div class="row row-grid align-items">
								<div class="col-sm-3">
									<h3 class="text-dark text-center mt-4 mb-0"><strong>Block</strong></h3>
								</div>
								<div class="col-sm-3">
									<h6 class="text-muted text-center float-center text-truncate mt-4 mb-4 py-2">{{this.$route.params.block}}</h6>
								</div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items">
					<card class="border-0" type="teal" noBody>
						<div class="pl-0">
							<div class="container">
								<div class="row row-grid align-items">
									<div class="col-lg-6">
										<img src="../assets/icons/cubes.png" align="left" style="width: 15px; padding-top: 6px;">
										<h6 class="text-white text-uppercase mb-1 px-4 text-left mt-1">Block Information</h6>
									</div>
								</div>
							</div>
						</div>
					</card>
				</div>
				<div class="order-lg-2 align-items mt-2 mb-4">
					<card type="secondary">
						<dl class="row">
							<dt class="col-md-3 col-sm">Height</dt>
							<dd class="col-md-9 col-sm">{{this.$route.params.block}}</dd>
							<dt class="col-md-3 col-sm">TimeStamp:</dt>
							<dd class="col-md-9 col-sm">{{block.timestamp | moment("from", "now")}} ({{block.timestamp | moment("dddd, MMMM Do YYYY, h:mm:ss a")}} +UTC)</dd>
							<dt class="col-md-3 col-sm">Transactions:</dt>
							<dd class="col-md-9 col-sm">{{block.transactions.length}}</dd>
							<dt class="col-md-3 col-sm">Hash:</dt>
							<dd class="col-md-9 col-sm">{{block.hash}}</dd>
							<dt class="col-md-3 col-sm">Parent Hash:</dt>
							<dd class="col-md-9 col-sm">{{block.parentHash}}</dd>
							<dt class="col-md-3 col-sm">Mined By:</dt>
							<dd class="col-md-9 col-sm">{{block.miner}}</dd>
							<dt class="col-md-3 col-sm">Gas Limit:</dt>
							<dd class="col-md-9 col-sm">{{block.gasLimit}}</dd>
							<dt class="col-md-3 col-sm">Nonce:</dt>
							<dd class="col-md-9 col-sm">{{block.nonce}}</dd>
						</dl>
					</card>
				</div>
			</div>
		</section>
	</div>
	<div v-else>
		<section>
			<div class="container col-lg-11 mt-5">
				<card noBody="" type="secondary" style="margin-top: 150px;">
					<div class="container">
						<div class="pl-0">
							<div class="row row-grid align-items">
								<div class="col-sm-3">
									<h3 class="text-dark text-left mt-4 mb-4"><strong>Block</strong></h3>
								</div>
								<div class="col-sm-5">
									<h6 class="text-muted text-left float-center text-truncate">{{this.$route.params.block}}</h6>
								</div>
								<div class="col-sm-4"></div>
							</div>
						</div>
					</div>
				</card>
			</div>
		</section>

		<section>
			<div class="container col-lg-11 mt-5">
				<div class="order-lg-1 align-items">
					<card class="border-0" type="teal" noBody>
						<div class="pl-0">
							<div class="container">
								<div class="row row-grid align-items">
									<div class="col-lg-6">
										<img src="../assets/icons/cubes.png" align="left" style="width: 15px; padding-top: 6px;">
										<h6 class="text-white text-uppercase mb-1 px-4 text-left mt-1">Block Information</h6>
									</div>
								</div>
							</div>
						</div>
					</card>
				</div>
				<div class="order-lg-2 align-items mt-2 mb-4">
					<card type="secondary">
						<h6 class="text-warning text-center">There are not marching entries</h6>
					</card>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
  data () {
    return {
      status: {},
      block: {
        transactions: '',
        timestamp: 1
      }
    }
  },
  mounted () {
    this.$http
      .get('get-blocks-info/' + this.$route.params.block)
      .then(response => {
        this.status = response.status
        return response.json()
      })
      .then(data => {
        this.block = data.blockInfo
      }, response => {
        this.status = response.status
      })
  },
  watch: {
    '$route.params.block': function () {
      this.block = {
        transactions: '',
        timestamp: 1
      }
      this.$http
        .get('get-blocks-info/' + this.$route.params.block)
        .then(response => {
          this.status = response.status
          return response.json()
        })
        .then(data => {
          this.block = data.blockInfo
        }, response => {
          this.status = response.status
        })
    }
  }
}
</script>

<style></style>
